// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tags-container:after{content:\"\";position:absolute;right:0;top:0;width:40px;height:100%}.tags-dark:after{background:#181819;background:linear-gradient(270deg,#181819,hsla(0,0%,100%,0))}.tags-light:after{background:#fff;background:linear-gradient(270deg,#fff,hsla(0,0%,100%,0))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
